import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { Action } from 'redux';

export interface ComplaintsDeleteAPIAction extends Action {
    readonly entity: string;
    readonly id: number;
}

export const COMPLAINTS_DELETE_API_REQUEST = 'COMPLAINTS_DELETE_API_REQUEST';

export interface ComplaintsDeleteAPIRequestAction extends ComplaintsDeleteAPIAction, APIRequestAction {
    readonly type: typeof COMPLAINTS_DELETE_API_REQUEST;
}

export const COMPLAINTS_DELETE_API_SUCCESS = 'COMPLAINTS_DELETE_API_SUCCESS';

export interface ComplaintsDeleteAPISuccessAction extends ComplaintsDeleteAPIAction, APISuccessAction {
    readonly type: typeof COMPLAINTS_DELETE_API_SUCCESS;
}

export const COMPLAINTS_DELETE_API_FAILURE = 'COMPLAINTS_DELETE_API_FAILURE';

export interface ComplaintsDeleteAPIFailureAction extends ComplaintsDeleteAPIAction, APIFailureAction {
    readonly type: typeof COMPLAINTS_DELETE_API_FAILURE;
}

export const complaintsDeleteAPI = {
    request: (entity: string, id: number): ComplaintsDeleteAPIRequestAction => ({
        type: COMPLAINTS_DELETE_API_REQUEST,
        entity, id,
    }),
    success: (entity: string, id: number, response: any): ComplaintsDeleteAPISuccessAction => ({
        type: COMPLAINTS_DELETE_API_SUCCESS, response,
        entity, id,
    }),
    failure: (entity: string, id: number, error: any): ComplaintsDeleteAPIFailureAction => ({
        type: COMPLAINTS_DELETE_API_FAILURE, error,
        entity, id,
    }),
};

export const COMPLAINTS_DELETE = 'COMPLAINTS_DELETE';

export interface ComplaintsDeleteAction extends ComplaintsDeleteAPIAction {
    readonly type: typeof COMPLAINTS_DELETE;
}

export const complaintsDelete = (entity: string, id: number): ComplaintsDeleteAction => ({
    type: COMPLAINTS_DELETE,
    entity, id,
});
